import React from 'react';
import PropTypes from 'prop-types';
import currencyMap from 'currency-symbol-map';


const Currency = ({ currency, className = '', attributes = {} }) => (
  <span
    className={className}
    {...attributes}
  >
    {currencyMap(currency)}
  </span>
);

Currency.propTypes = {
  currency: PropTypes.string.isRequired,
  className: PropTypes.string,
  attributes: PropTypes.object
};

export default Currency;
